export const OrderByEnum = {
    Ascending: 0,
    Descending: 1,
    None: 2,
}
